import React from 'react';
import { Field } from 'formik';
import { Form, InputGroup } from 'react-bootstrap';
import DateRangePicker from '../../../components/Form/DateRangePicker';

export default function DiscountBasicFields({
    values,
    setFieldValue,
    hideRmbDiscount,
}) {
    const totalDiscount = (
        (parseFloat(hideRmbDiscount ? 0 : values.rmbDiscount || 0) || 0) +
        (parseFloat(values.supplierDiscount || 0) || 0)
    ).toFixed(2);

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label className="fw-semibold mb-2">
                    Valid Date : <span className="text-danger">*</span>
                </Form.Label>
                <DateRangePicker
                    startDate={values.validStartDate}
                    endDate={values.validEndDate}
                    onChange={({ startDate, endDate }) => {
                        setFieldValue('validStartDate', startDate);
                        setFieldValue('validEndDate', endDate);
                    }}
                    maxDate={new Date('2027-12-31')}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="fw-semibold mb-2">
                    Rental Date : <span className="text-danger">*</span>
                </Form.Label>
                <DateRangePicker
                    startDate={values.rentStartDate}
                    endDate={values.rentEndDate}
                    onChange={({ startDate, endDate }) => {
                        setFieldValue('rentStartDate', startDate);
                        setFieldValue('rentEndDate', endDate);
                    }}
                    maxDate={new Date('2027-12-31')}
                />
            </Form.Group>

            <Field name="minDay">
                {({ field, meta }) => (
                    <Form.Group className="mb-3">
                        <Form.Label>Minimum rental days</Form.Label>
                        <Form.Control
                            {...field}
                            type="number"
                            min={0}
                            step="1"
                            isInvalid={meta.touched && !!meta.error}
                            placeholder="e.g. 1"
                        />
                    </Form.Group>
                )}
            </Field>

            {!hideRmbDiscount && (
                <Field name="rmbDiscount">
                    {({ field, meta }) => (
                        <Form.Group className="mb-3">
                            <Form.Label>RMB discount</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    {...field}
                                    type="number"
                                    min={0}
                                    step="0.01"
                                    isInvalid={meta.touched && !!meta.error}
                                    placeholder="e.g. 10"
                                />
                                <InputGroup.Text>%</InputGroup.Text>
                            </InputGroup>
                            <Form.Text className="text-muted">
                                Percentage off, e.g. 10 = 10%
                            </Form.Text>
                        </Form.Group>
                    )}
                </Field>
            )}

            <Field name="supplierDiscount">
                {({ field, meta }) => (
                    <Form.Group className="mb-3">
                        <Form.Label>Supplier discount</Form.Label>
                        <InputGroup>
                            <Form.Control
                                {...field}
                                type="number"
                                min={0}
                                step="0.01"
                                isInvalid={meta.touched && !!meta.error}
                                placeholder="e.g. 15"
                            />
                            <InputGroup.Text>%</InputGroup.Text>
                        </InputGroup>
                        <Form.Text className="text-muted">
                            Percentage off, e.g. 15 = 15%
                        </Form.Text>
                    </Form.Group>
                )}
            </Field>

            <Form.Group className="mb-3">
                <Form.Label>Total discount</Form.Label>
                <InputGroup>
                    <Form.Control type="text" readOnly value={`${totalDiscount} %`} />
                </InputGroup>
                <Form.Text className="text-muted">
                    Sum of visible discount items.
                </Form.Text>
            </Form.Group>
        </>
    );
}